<div class="downloaded-lesson">
  <div class="downloaded-lesson__nav">
    <a class="downloaded-lesson__back" routerLink="/user/managedownloads">&larr; Back to downloads</a>
    <a
      class="downloaded-lesson__live-link"
      *ngIf="!loading && !notFound && canGoToLiveLesson"
      routerLink="/user/lesson"
      [queryParams]="{ classid: classId, moduleid: moduleId }"
    >Go to live lesson page &rarr;</a>
  </div>

  <ng-container *ngIf="!loading">
    <ng-container *ngIf="!notFound; else notFoundBlock">
      <h2 class="downloaded-lesson__title">{{ lessonTitle }}</h2>

      <div class="lesson-main">
        <div class="lesson-main__head">
          <h3 class="lesson-main__title" *ngIf="currentBlock">{{ currentBlock.title }}</h3>
          <!-- No `m-0`: Bootstrap's m-0 is `margin: 0 !important` and beats the
               `margin-left: auto` that pushes this to the right of the head. -->
          <button type="button" class="btn btn--sm fs-enter"
            *ngIf="currentBlock && !currentBlock.empty"
            (click)="fs.toggle()"
            [attr.aria-pressed]="fs.active"
            title="Read full screen">
            <i class="fas fa-expand" aria-hidden="true"></i>
            <span class="fs-enter__label">Full screen</span>
          </button>
        </div>

        <div appExternallinksdirective class="lp-card lesson-note" *ngIf="currentBlock"
          [class.fs-surface]="fs.active"
          (mousemove)="fs.poke()" (click)="fs.tapped()">
          <app-lesson-game *ngIf="currentBlock.game" [game]="currentBlock.game"></app-lesson-game>
          <div class="innerHTML-wrap" *ngIf="!currentBlock.empty && !currentBlock.game" [innerHTML]="currentBlock.html"></div>
          <div class="lesson-note__empty" *ngIf="currentBlock.empty">
            <p class="lp-muted mb-0">There is nothing to read on this page.</p>
          </div>
        </div>

        <!-- Full-screen chrome — outside the card so the card's own scrolling cannot clip
             it. Same fade-on-idle behaviour as the live lesson page. -->
        <ng-container *ngIf="fs.active">
          <button type="button" class="btn fs-chrome fs-exit" [class.fs-chrome--hidden]="fs.chromeHidden"
            (click)="fs.set(false)" (mouseenter)="fs.hold()" (mouseleave)="fs.release()"
            title="Exit full screen">
            <i class="fas fa-compress" aria-hidden="true"></i>
            <span>Exit full screen</span>
          </button>

          <nav class="fs-chrome fs-bar" [class.fs-chrome--hidden]="fs.chromeHidden"
            (mouseenter)="fs.hold()" (mouseleave)="fs.release()" aria-label="Lesson pages">
            <button class="btn btn--sm" type="button" (click)="previousPage()" [disabled]="currentPage == 1">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
              <span>Previous</span>
            </button>
            <span class="fs-bar__count">Page {{ currentPage }} of {{ pages.length }}</span>
            <button class="btn btn--sm" type="button" (click)="nextPage()"
              [disabled]="currentPage == pages.length">
              <span>Next</span>
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </button>
          </nav>
        </ng-container>

        <div class="lesson-note__empty" *ngIf="pages.length === 0">
          <p class="lp-muted mb-0">This lesson has nothing saved to read.</p>
        </div>

        <nav class="lesson-pager" aria-label="Lesson pages" *ngIf="pages.length > 1">
          <button class="btn btn--sm m-0 lesson-pager__prev" (click)="previousPage()" type="button" [disabled]="currentPage == 1">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            <span>Previous</span>
          </button>

          <span class="lesson-pager__pages">
            <button
              type="button"
              class="lesson-pager__dot"
              *ngFor="let page of pages; let pageIndex = index"
              [class.is-current]="currentPage == pageIndex + 1"
              (click)="gotoPage(pageIndex + 1)"
              attr.aria-label="Go to page {{ pageIndex + 1 }}"
              [attr.aria-current]="currentPage == pageIndex + 1 ? 'true' : null"
            >{{ pageIndex + 1 }}</button>
          </span>
          <span class="lesson-pager__count">Page {{ currentPage }} of {{ pages.length }}</span>

          <button class="btn btn--sm m-0 lesson-pager__next" (click)="nextPage()" type="button" [disabled]="currentPage == pages.length">
            <span>Next</span>
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </nav>
      </div>
    </ng-container>
    <ng-template #notFoundBlock>
      <p class="lp-muted">This lesson isn't saved for offline use on this device.</p>
    </ng-template>
  </ng-container>
</div>
